export const limit_client_count = 20
export const limit_diseases_count = 15
export const limit_tag_count = 40
export const limit_log_count = 20
